import MagnifyBugOnLeafImage from "../../images/tasks/magnify-bug-on-leaf.jpeg";

export const pestsCalendar = [
  {
    name: "Pests and disease control",
    description:
      "Pests and diseases are organisms that occur where they are not wanted or that cause damage to crops or humans or other animals. Pests are organisms that damage or interfere with desirable plants in our fields and orchards, lawns, gardens, or forests.",
    learn: "https://www.youtube.com/watch?v=1Yb2x3b3n6o",
    frequency: "as needed",
    bestMonths: ["December", "February", "September"],
    otherMonths: "all",
    image: MagnifyBugOnLeafImage,
  },
  {
    name: "Alert for pests and diseases",
    description:
      "Pests and diseases are organisms that occur where they are not wanted or that cause damage to crops or humans or other animals. Pests are organisms that damage or interfere with desirable plants in our fields and orchards, lawns, gardens, or forests.",
    learn: "https://www.youtube.com/watch?v=1Yb2x3b3n6o",
    frequency: "as needed",
    bestMonths: ["August"],
    otherMonths: "all",
    image: MagnifyBugOnLeafImage,
  },
];
